import type { Editor } from '@tiptap/react';

import type { TAiEditPreview } from '@modules/documents/tiptap/plugins/AiEditReviewPlugin';

import { planAiEdit } from './aiEditPlan';
import { buildAiEditPreview, getAiEditNavigationElementIds, type TAiEditPreviewOptions } from './aiEditPreview';
import type { TAiEditSuggestion, TPlannedAiEdit } from './types';

type TPreparedAiEdit = {
  plan: TPlannedAiEdit;
  preview: TAiEditPreview;
  navigationElementIds: string[];
};

/** The one entry point into a review: the plan and what the user sees are always built together. */
export const prepareAiEdit = async (
  suggestions: TAiEditSuggestion[],
  editor: Editor,
  options: TAiEditPreviewOptions
): Promise<TPreparedAiEdit> => {
  const plan = planAiEdit(suggestions, editor.state);
  const preview = await buildAiEditPreview(plan, editor.schema, options);
  return { plan, preview, navigationElementIds: getAiEditNavigationElementIds(plan) };
};
